'use client'

// Compatibility re-export. The implementation lives in
// `@/contexts/auth-context` so the whole app shares one cookie read +
// one Genkan verify per page (mirrors catalog-frontend's pattern).
// Pre-existing call-sites import `useAuth` from `@/hooks/use-auth` —
// keep this shim so the migration to Genkan JWT in dojo doesn't have
// to touch every consumer.
export { useAuth } from '@/contexts/auth-context'
